import React from "react"

let withSkin = (Component) => {
  return (props) => {
    return <Component {...props} skinObject={(App && App.skinObject) || {}} />
  }
}

export default withSkin
